<info-page class="flex flex-row flex-center-center self-center" data-test-id="contact-points-error">
  <ng-template #image><img alt="" src="/assets/images/common/backgrounds/confirmation-bg.svg" /></ng-template>
  <ng-template #title>Your profile has been updated!</ng-template>
  <ng-template #description>
    <div class="description-text">
      Now it’s time for us to match you with projects perfectly aligned with your needs and goals!
      <br><br>
      You can update your profile anytime in settings.
    </div>
  </ng-template>
  <ng-template #actions>
    <div class="actions-wrapper">
      <a class="go-to-profile"
         color="primary"
         mat-flat-button
         href="https://my.7n.com/cv"
         target="_blank">
        Go to Profile
      </a>
    </div>
  </ng-template>
</info-page>
